import React, { useState, useCallback } from 'react';
import {
	Offcanvas,
	OffcanvasHeader,
	OffcanvasBody,
	Button,
	Form,
	Label,
	Row,
	Col,
} from 'reactstrap';
import Flatpickr from 'react-flatpickr';

const SupplyByCenterOffcanvas = ({ isOpen, toggle, filters, onSubmit }) => {
	const [localFilters, setLocalFilters] = useState({
		date_range: filters.date_range || [],
	});

	const handleDateChange = useCallback(dates => {
		setLocalFilters(prev => ({
			...prev,
			date_range: dates,
		}));
	}, []);

	const handleSubmit = useCallback(() => {
		onSubmit(localFilters);
		toggle();
	}, [localFilters, onSubmit, toggle]);

	const handleReset = useCallback(() => {
		const resetFilters = { date_range: [] };
		setLocalFilters(resetFilters);
		onSubmit(resetFilters);
		toggle();
	}, [onSubmit, toggle]);

	return (
		<Offcanvas isOpen={isOpen} direction='end' toggle={toggle}>
			<OffcanvasHeader toggle={toggle}>Filtros</OffcanvasHeader>
			<OffcanvasBody>
				<Form>
					<div className='mb-3'>
						<Label for='date_range'>Rango de Fechas</Label>
						<Flatpickr
							id='date_range'
							className='form-control'
							options={{
								mode: 'range',
								dateFormat: 'd/m/Y',
								defaultDate: localFilters.date_range,
							}}
							value={localFilters.date_range}
							onChange={handleDateChange}
						/>
					</div>

					<Row className='mt-4'>
						<Col>
							<Button
								color='primary'
								onClick={handleSubmit}
								className='w-100'
							>
								Aplicar
							</Button>
						</Col>
						<Col>
							<Button
								color='light'
								onClick={handleReset}
								className='w-100'
							>
								Limpiar
							</Button>
						</Col>
					</Row>
				</Form>
			</OffcanvasBody>
		</Offcanvas>
	);
};

export default SupplyByCenterOffcanvas;
